module.exports = __webpack_public_path__ + "img/Icons-38_mb.f227f2ea.jpg";